//taken from https://gist.github.com/vlucas/2bd40f62d20c1d49237a109d491974eb
const crypto = require('crypto');

const IV_LENGTH = 16; // For AES, this is always 16

function encrypt(text, encryptionKey) {
    if (!encryptionKey || encryptionKey.length !== 32) {
        throw new Error('AES encryption requires a 256 bit/32 char length encryption key');
    }
    let iv = crypto.randomBytes(IV_LENGTH);
    let cipher = crypto.createCipheriv('aes-256-ctr', Buffer.from(encryptionKey), iv);
    let encrypted = cipher.update(text);

    encrypted = Buffer.concat([encrypted, cipher.final()]);

    return iv.toString('hex') + ':' + encrypted.toString('hex');
}

function decrypt(text, encryptionKey) {
    if (!encryptionKey || encryptionKey.length !== 32) {
        throw new Error('AES encryption requires a 256 bit/32 char length encryption key');
    }
    let textParts = text.split(':');
    let iv = Buffer.from(textParts.shift(), 'hex');
    let encryptedText = Buffer.from(textParts.join(':'), 'hex');
    let decipher = crypto.createDecipheriv('aes-256-ctr', Buffer.from(encryptionKey), iv);
    let decrypted = decipher.update(encryptedText);

    decrypted = Buffer.concat([decrypted, decipher.final()]);

    return decrypted.toString();
}

module.exports = { decrypt, encrypt };
